import script from "./UserProfileImg.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileImg.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileImg.vue?vue&type=style&index=0&id=7c7c00ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7c00ca"]])

export default __exports__